module.exports = __webpack_public_path__ + "static-portal/img/hxzl.cf34d2a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/home/hxzl.jpg
// module id = 3isX
// module chunks = 4